import { AutogenModelFuelFundedVendorSubaccount, AutogenRowFuelFundedVendorSubaccount } from "./autogen/AutogenModelFuelFundedVendorSubaccount";

export class ModelFuelFundedVendorSubaccount extends AutogenModelFuelFundedVendorSubaccount<RowFuelFundedVendorSubaccount> {
	constructor() {
		super(RowFuelFundedVendorSubaccount);
	}
}

export class RowFuelFundedVendorSubaccount extends AutogenRowFuelFundedVendorSubaccount {
}